export default __webpack_public_path__ + "static/media/sync4.02aa902a.png";